import { render, staticRenderFns } from "./AddGasto.vue?vue&type=template&id=e425ea62&scoped=true"
import script from "./AddGasto.vue?vue&type=script&lang=js"
export * from "./AddGasto.vue?vue&type=script&lang=js"
import style0 from "./AddGasto.vue?vue&type=style&index=0&id=e425ea62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e425ea62",
  null
  
)

export default component.exports